import React from "react";
import { Loader2 } from "lucide-react";
import { Modal } from "../../../components/ui";

import { SupplierForm } from "./forms/SupplierForm";
import { ItemForm } from "./forms/ItemForm";
import { BrandForm } from "./forms/BrandForm";
import { CategoryForm } from "./forms/CategoryForm";
import { SubCategoryForm } from "./forms/SubCategoryForm";
import { StoreForm } from "./forms/StoreForm";
import { UnitForm } from "./forms/UnitForm";
import { RegisteredTypeForm } from "./forms/RegisteredTypeForm";
import { GenericForm } from "./forms/GenericForm";

export { InventoryViewModal } from "./InventoryViewModal";

export const InventoryFormModal = ({
  isOpen,
  onClose,
  activeTab,
  editingItem,
  form,
  setForm,
  errors,
  setErrors,
  onSubmit,
  dropdowns,
  isSubmitting,
}) => {
  const handleInputChange = (e) => {
    if (!e || !e.target) return;
    const field = e.target.name || e.target.id;
    if (!field) return;
    
    let value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    // Real-time Input Restrictions
    if (field === "mobile") value = value.replace(/\D/g, "").slice(0, 10);
    if (field === "accountNumber")
      value = value.replace(/\D/g, "").slice(0, 18);
    if (field === "ifscCode" || field === "gstNo")
      value = value.toUpperCase().replace(/\s/g, "");

    setForm((prev) => ({ ...prev, [field]: value }));
    
    // Clear error for this field if it exists
    if (errors && errors[field] && setErrors) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const getFormContent = () => {
    const props = { form, errors, handleInputChange, dropdowns, activeTab };
    if (activeTab === "vendor") return <SupplierForm {...props} />;
    if (activeTab === "item") return <ItemForm {...props} />;
    if (activeTab === "brand") return <BrandForm {...props} />;
    if (activeTab === "category") return <CategoryForm {...props} />;
    if (activeTab === "subCategory") return <SubCategoryForm {...props} />;
    if (activeTab === "stores") return <StoreForm {...props} />;
    if (activeTab === "unit") return <UnitForm {...props} />;
    if (activeTab === "registeredType") return <RegisteredTypeForm {...props} />;
    return <GenericForm {...props} />;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className="flex flex-col gap-0.5 z-10 relative">
          <span className="text-[14px] font-bold text-white font-serif tracking-widest uppercase">
            BLUM INTERIORS
          </span>
          <span className="text-[9px] text-slate-300 font-semibold tracking-widest uppercase">
            {editingItem ? "Modify" : "Add"} {activeTab}
          </span>
        </div>
      }
      size={activeTab === "vendor" || activeTab === "item" || activeTab === "stores" ? "lg" : "md"}
    >
      <div className="space-y-6">
        {getFormContent()}
        <div className="flex flex-col-reverse sm:flex-row items-center gap-3 pt-4 border-t border-slate-100 mt-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="w-full sm:flex-1 cursor-pointer py-2.5 border border-slate-200 hover:bg-slate-50 text-slate-800 rounded-md text-[12px] font-semibold transition-all duration-300 ease-in-out shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={isSubmitting}
            className="w-full sm:flex-1 flex items-center justify-center gap-2 cursor-pointer py-2.5 min-h-[38px] bg-slate-900 hover:bg-black text-white rounded-md text-[12px] font-bold transition-all duration-300 ease-in-out border border-slate-900 shadow-sm disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {isSubmitting && <Loader2 size={14} className="animate-spin" />}
            {editingItem ? "Save Changes" : "Save"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
